//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
import { makeStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
// import { getFormattedTime } from '../../common/dateHelper';
import { convertFileSize, getFileTypeLabelsByFilename } from '../../common/fileHelper';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdFileTypeIcon from '../../common/elemental/AfitdFileTypeIcon';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
import cx from 'clsx';
// import { format } from 'date-fns';
// import _get from 'lodash/get';
// import _set from 'lodash/set';
// import _map from 'lodash/map';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        //chatRightBlock2In
        root: {},
        contentContainerOut: {
            display: 'flex',
            justifyContent: 'space-between',
            background: '#FFFFFF',
            border: '1px solid #F0F2F6',
            padding: '12px',
            // fontSize: '16px',
            // lineHeight: '23px',
            borderRadius: '4px',
            // cursor: 'pointer',
        },
        fileInfoContainer: {
            flex: 1,
            marginLeft: '20px',
        },
        fileLink: {
            textDecoration: 'none',
        },
        //chatRightBlock2In small
        messageAgeText: {
            marginLeft: '10px',
            fontSize: '13px',
        },
        hidden: {
            display: 'none',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, props } = params;
    const { attachment, onClear, isClickable = true } = props;
    const { hidden: hiddenCls } = classes;
    const { size = 0, title = '', url = '' } = attachment;

    const { size: convertedSize, unit } = convertFileSize(size);
    const { label: typeLabel, labelLong: typeLabelLong } = getFileTypeLabelsByFilename(title);

    const defns = {
        fileLink: {
            target: '_blank',
            href: isClickable ? url : undefined,
        },
        fileTypeIcon: {
            label: typeLabel,
        },
        filenameText: {
            variant: 'body2',
            value: title,
        },
        fileTypeSizeText: {
            variant: 'caption',
            clsGrayColor: true,
            value: `${typeLabel} ${typeLabelLong} ${convertedSize}${unit}`,
        },
        clearIconButtonContainer: {
            className: cx({ [hiddenCls]: onClear === undefined }),
        },
        clearIconButton: {
            onClick: handleClickClearIconButton.bind(null, onClear),
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const handleClickClearIconButton = onClear => {
    if (onClear) onClear();
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const MessageFileBlock = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    // const context = useContext(LayoutContext);
    // const xxxxxx = _get(context, 'xxxxxx');

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [yyyyyyyyy, setYyyyyyyyy] = useState();

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { isHidden, attachment } = props;

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);

    //---------------------------------------------------------------------
    // useCallback
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    if (isHidden || !attachment) {
        return null;
    } else {
        //---------------------------------------------------------------------
        // Defns
        //---------------------------------------------------------------------
        const defns = getDefns({ classes, props });
        return (
            <div {...defns.root}>
                <a {...defns.fileLink}>
                    <div {...defns.contentContainerOut}>
                        <AfitdFileTypeIcon {...defns.fileTypeIcon} />
                        <div {...defns.fileInfoContainer}>
                            <AfitdTypography {...defns.filenameText} />
                            <AfitdTypography {...defns.fileTypeSizeText} />
                        </div>
                        <div {...defns.clearIconButtonContainer}>
                            <IconButton {...defns.clearIconButton}>
                                <ClearIcon />
                            </IconButton>
                        </div>
                    </div>
                </a>
            </div>
        );
    }
};

export default MessageFileBlock;
